import { onMount } from "svelte";
import { on } from "svelte/events";
import { requestSubmit } from "./requestSubmit";
import type { Props } from "../ButtonV1.types";

export const useFormSubmission = (
  Host: HTMLOcButtonV1Element,
  internals: ElementInternals,
  submitButton: () => HTMLElement | undefined,
  buttonType: () => Props["type"],
  loading: () => Props["loading"],
  isLoading: () => boolean,
): void => {
  /*                                      */
  let bouncerActive = false;

  $effect(() => {
    /*                                     */
    if (!isLoading()) {
      bouncerActive = false;
    }
  });

  /*                                                                        */
  /*                                    */
  onMount(() =>
    on(Host, "click", (event) => {
      /*                                                        */
      if (event.defaultPrevented) return;

      /*                                              */
      /*                                               */
      if (bouncerActive && isLoading() && loading() !== "keep-native-events") {
        event.stopPropagation();
        event.preventDefault();
        return;
      }

      /*                                                                         */
      /*                                      */
      if (buttonType() === "submit") {
        event.preventDefault();
        requestSubmit(internals.form, submitButton()!);

        /*                                         */
        bouncerActive = isLoading();
      } else if (buttonType() === "reset") {
        event.preventDefault();
        internals.form?.reset();
      }
    }),
  );
};
